<template>
	<div>
		<Navigation></Navigation>
	</div>
</template>

<script>
import ProfileNavigation from './ProfileNavigationComponent'
import Navigation from './NavigationComponent'

export default {
	components: {
		ProfileNavigation,
		Navigation
	},
    data() {
		return {
		}
    },
	methods: {
	},
    computed: {
    },
}
</script>
